// File: store/aboutMe.js
// Purpose: State store for the About Me view.
export default {
  header: "About Me",
  view: "AboutMe"
};
